import { themes } from './model'

// 修改页面中的样式变量值
const changeStyle = obj => {
  for (const key in obj) {
    document
      .getElementsByTagName('body')[0]
      .style.setProperty(`--${key}`, obj[key])
  }
}

// 改变主题的方法
export const setTheme = themeName => {
  localStorage.setItem('theme', themeName) // 保存主题到本地，下次进入使用该主题
  const themeConfig = themes[themeName]

  const themeKeys = Object.values(themes)[0]
  // 如果有主题名称，那么则采用我们定义的主题
  if (themeConfig) {
    // localStorage.setItem('baseColour', themeConfig.baseColour) // 保存主题色到本地
    // localStorage.setItem('baseColourTextColor', themeConfig.baseColourTextColor) // 保存文字颜色到本地
    // localStorage.setItem('logoColour', themeConfig.logoColour)
    // localStorage.setItem('asideClour', themeConfig.asideClour)

    // 遍历存储主题变量
    // console.log(Object.values(themes)[0])
    for (const key in themeKeys) {
      //   console.log(key)
      //   console.log('颜色', themeConfig[key])
      localStorage.setItem(key, themeConfig[key])
      changeStyle(themeConfig) // 改变样式
    }

    // changeStyle(themeConfig) // 改变样式
    // console.log('主题为', localStorage.getItem('theme'), themeConfig)
    // console.table(themeConfig)
  } else {
    const themeConfig = {}
    for (const key in themeKeys) {
      themeConfig[key] = localStorage.getItem(`${key}`)
    }
    changeStyle(themeConfig)

    // const themeConfig = {
    //   baseColour: localStorage.getItem('baseColour'),
    //   baseColourTextColor: localStorage.getItem('baseColourTextColor'),
    //   logoColour: localStorage.getItem('logoColour'),
    //   asideClour: localStorage.getItem('asideClour')
    // }
    // console.log('没有主题', themeConfig)
    // changeStyle(themeConfig)
  }
}
